import React, { useEffect, useState } from 'react';
import Text from '~components/atoms/Text';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import * as Styles from './_stockOut.module.scss';
import StockOutSearchAndFilterBar from './StockOutSearchAndFilterBar';
import StockOutTable from './StockOutTable';
import StockOutTablePaginator from './StockOutTablePaginator';
import ActionButton from '~components/atoms/ActionButton';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import CreateStockOutModal from './CreateStockOutModal';
import { MarketStatusEnum, ModuleEnum, PermissionsEnum } from '~utils/enums';

const StockOut = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.gold.modals.isCreateStockOutModalOpen);

    const handleOpenModal = () => dispatch(combinedActions.goldSetIsCreateStockOutModalOpen(true));
    const handleCloseModal = () => dispatch(combinedActions.goldSetIsCreateStockOutModalOpen(false));

    // const inventoryListingIndex = useAppSelector((state) => state.gold.goldInventory.inventoryListing.index);
    const viewAccessModules = useAppSelector(state => state.auth.userDetails.access)?.find(access => access.permission === PermissionsEnum.View)?.modules || [];
    const createAccessModules = useAppSelector(state => state.auth.userDetails.access)?.find(access => access.permission === PermissionsEnum.Edit)?.modules || [];

    const isMarketOpen = useAppSelector(state => state.dashboard.dashboardMarketStatus.status);

    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        dispatch(combinedActions.goldGetStockOutsAttempt());
        dispatch(combinedActions.goldGetAllProductsAttempt());
        dispatch(combinedActions.branchGetAllBranchesAttempt());

        dispatch(combinedActions.dashboardGetDashboardMarketStatusAttempt());

        const intervalId = setInterval(() => {
            dispatch(combinedActions.dashboardGetDashboardMarketStatusAttempt());
            dispatch(combinedActions.dashboardGetDashboardMarketStatusAttempt());
        }, 30000);

        return () => {
            clearInterval(intervalId); // cleanup on unmount
        };
    }, [dispatch]);

    const renderActionButtons = () => {
        if (viewAccessModules.find(module => module === ModuleEnum.StockOut)) {
            const isMarketClosed = isMarketOpen === MarketStatusEnum.Close;

            return (
                <div
                    className={Styles['button-wrapper']}
                    onMouseEnter={() => !isMarketClosed && setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    {
                        createAccessModules.find(module => module === ModuleEnum.StockOut)
                        &&
                        (
                            <>
                                <ActionButton
                                    label='+ Create Stock Out'
                                    onClick={handleOpenModal}
                                    disabled={!isMarketClosed}
                                    className={!isMarketClosed ? Styles['disabled-button'] : ''}
                                />

                                {
                                    !isMarketClosed && showTooltip &&
                                    (
                                        <div className={Styles.tooltip}>
                                            Stock Out can only be created when market is closed
                                        </div>
                                    )
                                }
                            </>
                        )
                    }
                </div>
            );
        }

        return null;
    };

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Stock Out'
                    className={Styles.title}
                    isBold
                />

                {renderActionButtons()}
            </TabPageHeaderWrapper>

            <StockOutSearchAndFilterBar />

            <StockOutTable />

            <StockOutTablePaginator />

            <CreateStockOutModal isOpen={isOpen} onClose={handleCloseModal} />
        </TabPageContainer>
    );
};

export default StockOut;
